import Constants from "utils/Constants";
import { useRef, useState, forwardRef, useImperativeHandle } from "react";
import useKeyEvent from "hooks/useKeyEvent";
import TextRecordDrawer from "./TextRecordDrawer";
import TextRecordNoDrawer from "./TextRecordNoDrawer";
import { callFunctionIfExists } from "utils/GeneralUtils";

const TextRecord = (
  {
    tableView,
    recordID,
    type,
    field,
    existingValue,
    modifyTrigger,
    inputSize,
    mode,
    onUpdate,
    submitting,
    error,
    isDrawer,
  },
  ref
) => {
  const whisperRef = useRef();
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState(null);
  const [localError, setLocalError] = useState(null);

  /**
   *
   * @param {Function} onSuccessFunction
   * Void function to call the close whisper function.
   */
  const save = (onSuccessFunction) => {
    setLocalError(null);
    if (
      (field.FieldType === Constants.FIELDTYPES.NUMBER ||
        field.FieldType === Constants.FIELDTYPES.PERCENT) &&
      value &&
      isNaN(value)
    ) {
      return setLocalError("The value for this field must be numeric.");
    }

    onUpdate({
      field,
      recordID,
      payload: { [field.APIName]: value },
      onSuccess: () => {
        stopEditing();
        callFunctionIfExists(onSuccessFunction);
      },
    });
  };

  const openModify = () => {
    setIsEditing(true);
    setValue(existingValue);
    whisperRef?.current?.open?.();
  };

  const stopEditing = () => {
    setIsEditing(false);
    setValue(null);
    whisperRef?.current?.close?.();
  };

  const handleChange = (newValue) => {
    setValue(newValue);
  };

  useKeyEvent(stopEditing);

  const isDisabled = submitting;

  useImperativeHandle(ref, () => ({
    focus: () => {
      whisperRef?.current?.focus();
    },
  }));

  // Currently using Mantine when this record field is opened inside a Drawer and using Rsuite when opened in non-drawer (Main table)
  // Using Mantine in both causes issues in multisubitems and using Rsuite loses focus on enter
  // isDrawer was here in place of true
  return true ? (
    <TextRecordDrawer
      tableView={tableView}
      field={field}
      stopEditing={stopEditing}
      type={type}
      isDisabled={isDisabled}
      save={save}
      existingValue={existingValue}
      inputSize={inputSize}
      handleChange={handleChange}
      value={value}
      submitting={submitting}
      localError={localError}
      error={error}
      mode={mode}
      modifyTrigger={modifyTrigger}
      openModify={openModify}
      ref={whisperRef}
    />
  ) : (
    <TextRecordNoDrawer
      isEditing={isEditing}
      setIsEditing={setIsEditing}
      tableView={tableView}
      field={field}
      stopEditing={stopEditing}
      type={type}
      isDisabled={isDisabled}
      save={save}
      existingValue={existingValue}
      inputSize={inputSize}
      handleChange={handleChange}
      value={value}
      submitting={submitting}
      localError={localError}
      error={error}
      mode={mode}
      modifyTrigger={modifyTrigger}
      openModify={openModify}
    />
  );
};

export default forwardRef(TextRecord);
